// Action Types
export const SET_TRENDS = 'trends/setTrends'
export const SET_ENDING_SENTIMENT = 'trends/setEndingSentiment'
export const SET_LOADING = 'trend/setLoading'
export const SET_TREND_COUNT = 'trend/setTrendCount'
export const SET_TREND = 'trend/setTrend'
export const SET_TAXONOMY = 'trend/setTaxonomy'
export const RESET_TREND = 'trend/resetTrend'

// Action Creators
export const setTrends = (payload) => ({ type: SET_TRENDS, payload })
export const setEndingSentiment = (payload) => ({ type: SET_ENDING_SENTIMENT, payload })
export const setLoading = (payload) => ({ type: SET_LOADING, payload })
export const setTrendCount = (payload) => ({ type: SET_TREND_COUNT, payload })
export const setTrend = (payload) => ({ type: SET_TREND, payload })
export const setTaxonomy = (payload) => ({ type: SET_TAXONOMY, payload })
export const resetTrend = (payload) => ({ type: RESET_TREND, payload })

const TREND_INITIAL_STATE = {
  call_filters: [],
  created_by: '',
  id: null,
  name: '',
  order: null,
  organization_id: null,
  precondition_statements: [],
  precondition_questions: [],
  question: '',
  taxonomy_uuid: null,
  data: [],
  backfill_status: '',
  display_filters: [],
}

// State
export const initialState = {
  trend: {
    ...TREND_INITIAL_STATE,
  },
  trends: [],
  endingSentiment: { sentiments: {}, time_series: [] },
  loading: {
    trends: false,
    trend: false,
    endingSentiment: false,
  },
  total_tracked: 0,
  limit: 0,
  allow_creation: true,
}

export default function trendsReducer(state = initialState, action) {
  const { payload, type } = action

  switch (type) {
    case SET_TRENDS:
      return { ...state, trends: payload }
    case SET_ENDING_SENTIMENT:
      return { ...state, endingSentiment: payload }
    case SET_LOADING:
      return { ...state, loading: { ...state.loading, ...payload } }
    case SET_TREND_COUNT:
      return { ...state, ...payload }
    case SET_TREND:
      return { ...state, trend: { ...payload } }
    case SET_TAXONOMY:
      return { ...state, taxonomy_uuid: payload }
    case RESET_TREND:
      return { ...state, trend: { ...TREND_INITIAL_STATE } }
    default:
      return state
  }
}
